import {
  PTOM_PLAN_ACCOUNT,
  PTOM_PLAN_DETAIL,
  REPORT_COMPLEX,
  REPORT_REALTIME,
  REPORT_MATERIAL_ANALYSIS,
  REPORT_MATERIAL_ANALYSIS_DATE,
  REPORT_LABEL_LIFECYCLE,
  REPORT_LABEL_GROUP_ANALYSIS,
  REPORT_AD_POSITION
} from './const.js'
import { PLATFORM_LIST } from '@/common/js/constants.js'
import { dimensionsData } from '@/views/report/comprehension-report/js/dimensionsData.js'
/**
 * @description: 转换查询条件为可读的字符串
 * @param {*} conditions
 * @param {*} pageType
 * @return {*}
 */
export function transferTaskQueryConditions(conditions, pageType) {
  switch (pageType) {
    case PTOM_PLAN_DETAIL:
      return getPtomPlanConditions.call(this, conditions)
    case PTOM_PLAN_ACCOUNT:
      return getPtomAccountConditions.call(this, conditions)
    case REPORT_COMPLEX:
      return getComplexReportConditions.call(this, conditions)
    case REPORT_REALTIME:
      return getRealtimeReportConditions.call(this, conditions)
    case REPORT_MATERIAL_ANALYSIS:
      return getMaterialAnalysisConditions.call(this, conditions)
    case REPORT_MATERIAL_ANALYSIS_DATE:
      return getMaterialAnalysisByDateConditions.call(this, conditions)
    case REPORT_LABEL_LIFECYCLE:
      return getMaterialLabelLifeCycleConditions.call(this, conditions)
    case REPORT_LABEL_GROUP_ANALYSIS:
      return getMaterialLabelGroupConditions.call(this, conditions)
    case REPORT_AD_POSITION:
      return getAdPositionReportConditions.call(this, conditions)
    // case DESIGNER_PERSONAL:
    //   return getDesignerPersonalConditions.call(this, conditions)
    default:
      return {
        ...conditions
      }
  }
}

/**
 * @description: 投放计划明细
 * @param {*} conditions
 * @return {*}
 */
function getPtomPlanConditions(conditions) {
  const arr = []
  if (conditions.planName) arr.push(['计划名称', conditions.planName])
  if (conditions.imageName) arr.push(['素材名称', conditions.imageName])
  if (conditions.landingPageIdStr) arr.push(['落地页', conditions.landingPageIdStr])
  if (conditions.platform && conditions.platform !== '0') {
    arr.push(['平台', PLATFORM_LIST.find((i) => i.value === conditions.platform).label])
  }
  if (conditions.gameGroupId) arr.push(['游戏组', this.GAME_GROUPS.find((i) => i.id === conditions.gameGroupId).name])
  if (conditions.gameId) arr.push(['游戏', this.GAMES.find((i) => i.id === conditions.gameId).name])
  if (conditions.mediaId) arr.push(['媒体', this.MEDIAS.find((i) => i.id === conditions.mediaId).name])
  if (conditions.advPositionId) arr.push(['投放位', this.AdvertPositionData.find((i) => i.id === conditions.advPositionId).name])
  if (conditions.optimizationType) arr.push(['优化目标', this.optimizationData.find((i) => i.id === conditions.optimizationType).name])
  if (conditions.deepOptimizationType) {
    arr.push(['深度优化', this.deepOptimizationData.find((i) => i.id === conditions.deepOptimizationType).name])
  }
  if (conditions.projectGroupId) arr.push(['项目组', this.PROJECT_GROUP.find((i) => i.id === conditions.projectGroupId).name])
  if (conditions.opId) arr.push(['人员', this.PTOM_USERS.find((i) => i.id === conditions.opId).name])
  if (conditions.adAccountId) arr.push(['账号', this.MEDIA_ACCOUNTS.find((i) => i.id === conditions.adAccountId).name])
  if (conditions.bindMaterial) arr.push(['素材绑定', this.materialBindList.find((i) => i.id === conditions.bindMaterial).name])
  if (conditions.mediaOptStatus) {
    arr.push(['操作状态', this.planStatus.adSwitchStatusEnums.find((i) => i.chEnum === conditions.mediaOptStatus).chName])
  }
  if (conditions.mediaStatusStr) {
    arr.push(['计划状态', this.planStatus.adStatusEnums.find((i) => i.chEnum === Number(conditions.mediaStatusStr)).chName])
  }
  if (conditions.proxyFlag) {
    arr.push(['是否代投', this.proxyStatus.find((i) => i.id === conditions.proxyFlag).name])
  }
  if (conditions.createBeginTime && conditions.createEndTime) {
    arr.push(['新建时间', `${conditions.createBeginTime} ~ ${conditions.createEndTime}`])
  }
  if (conditions.beginTime && conditions.endTime) arr.push(['开始结束时间', `${conditions.beginTime} ~ ${conditions.endTime}`])
  return arr.map((i) => i.join('：')).join('；')
}

/**
 * @description: 投放账号明细
 * @param {*} conditions
 * @return {*}
 */
function getPtomAccountConditions(conditions) {
  const arr = []
  if (conditions.adAccountIdStr) arr.push(['账号', this.MEDIA_ACCOUNTS.find((i) => i.id === Number(conditions.adAccountIdStr)).name])
  if (conditions.platform && conditions.platform !== '0') {
    arr.push(['平台', PLATFORM_LIST.find((i) => i.value === conditions.platform).label])
  }
  if (conditions.gameGroupId) arr.push(['游戏组', this.GAME_GROUPS.find((i) => i.id === conditions.gameGroupId).name])
  if (conditions.gameId) arr.push(['游戏', this.GAMES.find((i) => i.id === conditions.gameId).name])
  if (conditions.mediaId) arr.push(['媒体', this.MEDIAS.find((i) => i.id === conditions.mediaId).name])
  if (conditions.advPositionId) arr.push(['投放位', this.AdvertPositionData.find((i) => i.id === conditions.advPositionId).name])
  if (conditions.optimizationType) arr.push(['优化目标', this.optimizationData.find((i) => i.id === conditions.optimizationType).name])
  if (conditions.deepOptimizationType) {
    arr.push(['深度优化', this.deepOptimizationData.find((i) => i.id === conditions.deepOptimizationType).name])
  }
  if (conditions.projectGroupId) arr.push(['项目组', this.PROJECT_GROUP.find((i) => i.id === conditions.projectGroupId).name])
  if (conditions.opId) arr.push(['人员', this.SYS_USERS.find((i) => i.id === conditions.opId).name])
  if (conditions.managerId) arr.push(['管理人员', this.SYS_USERS.find((i) => i.id === conditions.managerId).name])
  if (conditions.beginTime && conditions.endTime) arr.push(['开始结束时间', `${conditions.beginTime} ~ ${conditions.endTime}`])

  return arr.map((i) => i.join('：')).join('；')
}

function commonComplexReportConditions(conditions) {
  const arr = []

  if (conditions.ptomPlan?.length) {
    const str = this.planTags.map((i) => i.name).join('、')
    arr.push(['计划', str])
  }
  if (conditions.ptomImage?.length) {
    const str = this.imageTags.map((i) => i.name).join('、')
    arr.push(['素材', str])
  }
  if (conditions.platforms?.length) {
    const str = PLATFORM_LIST.filter((i) => conditions.platforms.includes(i.value))
      .map((i) => i.label)
      .join('、')
    arr.push(['平台', str])
  }
  if (conditions.gameGroupIds?.length) {
    const str = this.GAME_GROUPS.filter((i) => conditions.gameGroupIds.includes(i.id))
      .map((i) => i.name)
      .join('、')
    arr.push(['游戏组', str])
  }
  if (conditions.gameIds?.length) {
    const str = this.GAMES.filter((i) => conditions.gameIds.includes(i.id))
      .map((i) => i.name)
      .join('、')
    arr.push(['游戏', str])
  }
  if (conditions.initProjectGroupIds?.length) {
    const str = this.PROJECT_GROUP.filter((i) => conditions.initProjectGroupIds.includes(i.id))
      .map((i) => i.name)
      .join('、')
    arr.push(['项目组', str])
  }
  if (conditions.opIds?.length) {
    const str = this.PTOM_USERS.filter((i) => conditions.opIds.includes(i.id))
      .map((i) => i.name)
      .join('、')
    arr.push(['人员', str])
  }

  if (conditions.mediaIds?.length) {
    const str = this.MEDIAS.filter((i) => conditions.mediaIds.includes(i.id))
      .map((i) => i.name)
      .join('、')
    arr.push(['媒体', str])
  }

  if (conditions.subMediaIds?.length) {
    const str = this.subMediaOptions
      .filter((i) => conditions.subMediaIds.includes(i.value))
      .map((i) => i.label)
      .join('、')
    arr.push(['媒体版本', str])
  }

  if (conditions.advPositionIds?.length) {
    const str = this.advertPositionData
      .filter((i) => conditions.advPositionIds.includes(i.id))
      .map((i) => i.name)
      .join('、')
    arr.push(['投放位', str])
  }

  if (conditions.adAccountIdList?.length) {
    const str = this.MEDIA_ACCOUNTS.filter((i) => conditions.adAccountIdList.includes(i.id))
      .map((i) => i.name)
      .join('、')
    arr.push(['账号', str])
  }

  if (conditions.optimizationTypes?.length) {
    const str = this.optimizationData
      .filter((i) => conditions.optimizationTypes.includes(i.id))
      .map((i) => i.name)
      .join('、')
    arr.push(['优化目标', str])
  }

  if (conditions.deepOptimizationTypes?.length) {
    const str = this.deepOptimizationData
      .filter((i) => conditions.deepOptimizationTypes.includes(i.id))
      .map((i) => i.name)
      .join('、')
    arr.push(['深度优化目标', str])
  }

  if (typeof conditions.proxyFlag === 'number') {
    const str = this.proxyStatus
      .filter((i) => conditions.proxyFlag === i.value)
      .map((i) => i.name)
      .join('、')
    arr.push(['是否代投', str])
  }
  if (typeof conditions.launchSource === 'number') {
    const str = this.launchSourceData
      .filter((i) => conditions.launchSource === i.value)
      .map((i) => i.label)
      .join('、')
    arr.push(['流量来源', str])
  }
  if (conditions.beginDate && conditions.endDate) arr.push(['开始结束时间', `${conditions.beginDate} ~ ${conditions.endDate}`])

  const dimensions = []
  for (const i in conditions) {
    if (i.startsWith('dim')) {
      if (!conditions[i]) continue
      const title = dimensionsData.find((j) => i === j.showKey)?.title
      title && dimensions.push(title)
    }
  }

  if (dimensions.length) {
    arr.push(['维度', dimensions.join('、')])
  }

  return arr
}

/**
 * @description: 综合效果报表
 * @param {*} conditions
 * @return {*}
 */
function getComplexReportConditions(conditions) {
  const arr = []

  const commonConditions = commonComplexReportConditions.call(this, conditions)

  if (conditions.launchModes?.length) {
    const str = this.launchModesData
      .filter((i) => conditions.launchModes.includes(i.id))
      .map((i) => i.name)
      .join('、')
    arr.push(['投放模式', str])
  }
  if (conditions.biddingStrategys?.length) {
    const str = this.biddingStrategysData
      .filter((i) => conditions.biddingStrategys.includes(i.id))
      .map((i) => i.name)
      .join('、')
    arr.push(['竞价策略', str])
  }

  if (conditions.nativeAdverts?.length) {
    const str = this.nativeAdvertsData
      .filter((i) => conditions.nativeAdverts.includes(i.id))
      .map((i) => i.name)
      .join('、')
    arr.push(['原生计划', str])
  }
  if (conditions.douyinNos?.length) {
    const str = this.douyinList
      .filter((i) => conditions.douyinNos.includes(i.accountId))
      .map((i) => i.accountName)
      .join('、')
    arr.push(['抖音号', str])
  }
  if (conditions.shipinNos?.length) {
    const str = this.weixinList
      .filter((i) => conditions.shipinNos.includes(i.accountId))
      .map((i) => i.accountName)
      .join('、')
    arr.push(['视频号', str])
  }
  if (conditions.kuanshouNos?.length) {
    const str = this.kuaishouList
      .filter((i) => conditions.kuanshouNos.includes(i.accountId))
      .map((i) => i.accountName)
      .join('、')
    arr.push(['快手号', str])
  }
  if (conditions.proxyAccountIds?.length) {
    const str = this.AGENTS.filter((i) => conditions.proxyAccountIds.includes(i.id))
      .map((i) => i.name)
      .join('、')
    arr.push(['代投账号', str])
  }

  if (conditions.genders?.length) {
    const str = this.genderData
      .filter((i) => conditions.genders.includes(i.id))
      .map((i) => i.name)
      .join('、')
    arr.push(['性别', str])
  }

  if (conditions.deliveryTypes?.length) {
    const str = this.deliveryTypeList
      .filter((i) => conditions.deliveryTypes.includes(i.code))
      .map((i) => i.name)
      .join('、')
    arr.push(['投放类型', str])
  }

  return commonConditions
    .concat(arr)
    .map((i) => i.join('：'))
    .join('；')
}

/**
 * @description: 综合效果实时报表
 * @param {*} conditions
 * @return {*}
 */
function getRealtimeReportConditions(conditions) {
  const commonConditions = commonComplexReportConditions.call(this, conditions)
  return commonConditions.map((i) => i.join('：')).join('；')
}

function getMaterialAnalysisConditions(conditions) {
  const arr = []
  if (conditions.gameGroupId) arr.push(['素材游戏组', this.gameGroups.find((i) => i.id === conditions.gameGroupId).name])
  if (conditions.dataGroupId) arr.push(['数据游戏组', this.gameGroups.find((i) => i.id === conditions.dataGroupId).name])
  if (conditions.uploadBeginTime && conditions.uploadEndTime) {
    arr.push(['上传时间', `${conditions.uploadBeginTime} ~ ${conditions.uploadEndTime}`])
  }
  if (conditions.beginTime && conditions.endTime) {
    arr.push(['统计时间', `${conditions.beginTime} ~ ${conditions.endTime}`])
  }
  if (conditions.designerIds?.length) {
    arr.push([
      '设计者',
      this.sysUsers
        .filter((i) => conditions.designerIds.includes(i.id))
        .map((i) => i.name)
        .join('、')
    ])
  }
  if (conditions.plannerIds?.length) {
    arr.push([
      '策划者',
      this.sysUsers
        .filter((i) => conditions.plannerIds.includes(i.id))
        .map((i) => i.name)
        .join('、')
    ])
  }
  if (conditions.gameIds?.length) {
    arr.push([
      '素材游戏',
      this.games
        .filter((i) => conditions.gameIds.includes(i.id))
        .map((i) => i.name)
        .join('、')
    ])
  }
  if (conditions.dataGameIds?.length) {
    arr.push([
      '数据游戏',
      this.games
        .filter((i) => conditions.dataGameIds.includes(i.id))
        .map((i) => i.name)
        .join('、')
    ])
  }
  if (conditions.mediaIds?.length) {
    arr.push([
      '媒体',
      this.mediaList
        .filter((i) => conditions.mediaIds.includes(i.id))
        .map((i) => i.name)
        .join('、')
    ])
  }
  if (conditions.imgTypes?.length) {
    arr.push([
      '素材类型',
      this.imageTypes
        .filter((i) => conditions.imgTypes.includes(i.id))
        .map((i) => i.name)
        .join('、')
    ])
  }
  if (conditions.imageStyle) arr.push(['素材样式', this.imageStyles.find((i) => i.id === conditions.imageStyle).content])

  if (conditions.labelIdsStr) {
    const labelIds = conditions.labelIdsStr.split(',').map((i) => Number(i))
    const str = this.sysTags
      .filter((i) => labelIds.includes(i.id))
      .map((i) => i.name)
      .join('、')
    arr.push(['内容标签', str])
  }
  if (conditions.launchOpIdsStr) {
    const launchOpIdList = conditions.launchOpIdsStr.split(',').map((i) => Number(i))
    const str = this.sysUsers
      .filter((i) => launchOpIdList.includes(i.id))
      .map((i) => i.name)
      .join('、')
    arr.push(['投放人', str])
  }
  if (conditions.lauchTimeBegin && conditions.lauchTimeEnd) {
    arr.push(['消耗起始时间', `${conditions.lauchTimeBegin} ~ ${conditions.lauchTimeEnd}`])
  }
  return arr.map((i) => i.join('：')).join('；')
}

/**
 * @description: 素材分析-分日
 * @param {*} conditions
 * @return {*}
 */
function getMaterialAnalysisByDateConditions(conditions) {
  const arr = []
  if (conditions.mediaId) arr.push(['媒体', this.MEDIAS.find((i) => i.id === conditions.mediaId).name])

  arr.push(['素材ID', conditions.id])
  arr.push(['素材名称', conditions.name])
  arr.push(['设计者', conditions.author])
  arr.push(['上传时间', conditions.creatime])
  arr.push(['起投时间', conditions.begintime])
  arr.push(['最后投放时间', conditions.endtime])
  if (conditions.beginTime && conditions.endTime) {
    arr.push(['起始时间', `${conditions.beginTime} ~ ${conditions.endTime}`])
  }

  return arr.map((i) => i.join('：')).join('；')
}

/**
 * @description: 素材分析-内容标签曲线
 * @param {*} conditions
 * @return {*}
 */
function getMaterialLabelLifeCycleConditions(conditions) {
  const arr = []
  if (conditions.labelIds?.length) {
    const str = this.sysTagList
      .filter((i) => conditions.labelIds.includes(i.id))
      .map((i) => i.name)
      .join('、')
    arr.push(['标签', str])
  }

  if (conditions.labelGroupList?.length) {
    const str = this.SYS_TAG_GROUPS.filter((i) => conditions.labelGroupList.includes(i.id))
      .map((i) => i.name)
      .join('、')
    arr.push(['标签组', str])
  }

  if (conditions.mediaId) arr.push(['媒体', this.MEDIAS.find((i) => i.id === conditions.mediaId).name])
  if (conditions.typeLabelIds) {
    const str = this.SYS_LARGE_TAG.filter((i) => conditions.typeLabelIds.includes(i.id))
      .map((i) => i.name)
      .join('、')
    arr.push(['营销主题标签', str])
  }

  if (conditions.beginTime && conditions.endTime) {
    arr.push(['起始时间', `${conditions.beginTime} ~ ${conditions.endTime}`])
  }

  return arr.map((i) => i.join('：')).join('；')
}

/**
 * @description: 素材分析-标签组
 * @param {*} conditions
 * @return {*}
 */
function getMaterialLabelGroupConditions(conditions) {
  const arr = []
  if (conditions.labelGroupList?.length) {
    const str = this.SYS_TAG_GROUPS.filter((i) => conditions.labelGroupList.includes(i.id))
      .map((i) => i.name)
      .join('、')
    arr.push(['标签组', str])
  }

  if (conditions.mediaId) arr.push(['媒体', this.MEDIAS.find((i) => i.id === conditions.mediaId).name])
  if (conditions.typeLabelIds) {
    const str = this.SYS_LARGE_TAG.filter((i) => conditions.typeLabelIds.includes(i.id))
      .map((i) => i.name)
      .join('、')
    arr.push(['营销主题标签', str])
  }

  if (conditions.beginTime && conditions.endTime) {
    arr.push(['起始时间', `${conditions.beginTime} ~ ${conditions.endTime}`])
  }

  return arr.map((i) => i.join('：')).join('；')
}

/**
 * @description: 广告位报表
 * @param {*} conditions
 * @return {*}
 */
function getAdPositionReportConditions(conditions) {
  const commonConditions = commonComplexReportConditions.call(this, conditions)
  return commonConditions.map((i) => i.join('：')).join('；')
}
/**
 * @description: 设计师个人报表（废弃）
 * @return {*}
 */
function getDesignerPersonalConditions(conditions) {
  const arr = []

  if (conditions.gameGroupIds?.length) {
    const str = this.GAME_GROUPS.filter((i) => conditions.gameGroupIds.includes(i.id))
      .map((i) => i.name)
      .join('、')
    arr.push(['游戏组', str])
  }

  if (conditions.gameIds?.length) {
    const str = this.POPULAR_GAMES.filter((i) => conditions.gameIds.includes(i.id))
      .map((i) => i.name)
      .join('、')
    arr.push(['游戏', str])
  }

  if (conditions.imageStyles?.length) {
    const childList = conditions.imageStyles.map((i) => i[1])
    const str = this.IMAGE_STYLE_TAG_TREE.map((i) => i.children?.filter((j) => childList.includes(j.labelId)).map((j) => j.labelPath))
      .filter((i) => i.length)
      .join('、')
    arr.push(['素材样式', str])
  }

  if (conditions.projectGroupId) arr.push(['项目组', this.PROJECT_GROUP.find((i) => i.id === conditions.projectGroupId).name])
  if (conditions.date?.length) arr.push(['上传时间', `${conditions.date[0]} ~ ${conditions.date[1]}`])

  return arr.map((i) => i.join('：')).join('；')
}
